import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'are_workers_paid_during_breastfeeding_breaks_line_legal'

export const dataPointDefinition = {
  retracedId: 'are_workers_paid_during_breastfeeding_breaks_line_legal',
  name: 'Are workers paid during breastfeeding breaks in line with legal requirements?',
  description: 'This includes payment of hourly wage and piece-rate workers.',
  meta: {
    slcpMeta: {
      key: 'wh-8--1-1f',
      number: 'WB-WAGE-147',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wh-8--1-1f', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36320,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
